// All files collected from the USGS Earthquake API using cUrl Eg:
// curl -X GET -o 20140902_0M.geojson 'https://earthquake.usgs.gov/fdsnws/event/1/query.geojson?starttime=2014-09-02%2000:00:00&endtime=2014-09-02%2023:59:59&minmagnitude=0&eventtype=earthquake&orderby=time-asc'

const quake_metadata = [
  {
    date: "2014-09-02",
    desc: "September 2, 2014 - Release date for 'Tezos — a self-amending crypto-ledger White paper L.M Goodman'.",
    filename: "./data/20140902_0M.geojson",
  },
  {
    date: "2018-06-30",
    desc: "June 30, 2018 - Tezos Initial Release.",
    filename: "./data/20180630_0M.geojson",
  },
  {
    date: "2021-11-06",
    desc: "November 6, 2021 - Date of the Genesis drop on fxhash. The fxhash logo identity.",
    filename: "./data/20211106_0M.geojson",
  },
  {
    date: "2021-11-07",
    desc: "November 7, 2021 - ciphrd drops 'RGB Elementary Cellular Automaton', and punevyr drops 'Punevyr's face'.",
    filename: "./data/20211107_0M.geojson",
  },
  {
    date: "2021-11-11",
    desc: "November 11, 2021 - markknol drops 'SMOLSKULL'.",
    filename: "./data/20211111_0M.geojson",
  },
  {
    date: "2021-12-09",
    desc: "December 9, 2021 - zancan drops 'Garden, Monoliths', xiiixiii drops 'Repeater' and Erik Swahn drops 'Farbteiler'.",
    filename: "./data/20211209_0M.geojson",
  },
  {
    date: "2022-01-02",
    desc: "January 2, 2022 - willpop.tez and Trinity drop first episode of the 'Waiting To Be Signed' podcast.",
    filename: "./data/20220102_0M.geojson",
  },
  {
    date: "2022-03-31",
    desc: "March 31, 2022 - 'The Big Burn', marking the end of fxhash in beta.",
    filename: "./data/20220331_0M.geojson",
  },
  {
    date: "2022-04-16",
    desc: "April 16, 2022 - fxhash 1.0 drops.",
    filename: "./data/20220416_0M.geojson",
  },
  {
    date: "2022-05-27",
    desc: "March 27, 2022 - Opening day of Art Basel Hong Kong, 2022, 'NFTs + The Ever-Evolving World of Art'. First ever live-minting event.",
    filename: "./data/20220527_0M.geojson",
  },
  {
    date: "2022-07-18",
    desc: "July 18, 2022 - Last full day of data before Boom_fx is published to fxhash.xyz",
    filename: "./data/20220718_0M.geojson",
  },
];

export { quake_metadata };
